import { Location } from '@angular/common'
import { inject, InjectionToken } from '@angular/core'

import { RoutePath } from 'app/static/route-path.enum'

/** indicates whether the current location path is in preview mode */
export const IS_PREVIEW = new InjectionToken<boolean>(ngDevMode ? 'IS_PREVIEW' : '', {
  providedIn: 'root',
  factory: () => inject(Location).path().startsWith(`/${RoutePath.PREVIEW}`),
})
